module.exports = __webpack_public_path__ + "media/images/official/event_fukidashi2-3cbb7c3e1047d5d4075c74ca8c686540.png";